export default __webpack_public_path__ + "static/media/chicken_burrito.ffebfecc.mp3";